import { render, staticRenderFns } from "./DialogDestinoCashposto.vue?vue&type=template&id=45bfb464&"
import script from "./DialogDestinoCashposto.vue?vue&type=script&lang=js&"
export * from "./DialogDestinoCashposto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports